import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTRPC } from "../../../../trpc.js";
import { useMapkaNotification } from "../../../../hooks/notifications.js";
import { useIntl } from "react-intl";
import { useCallback } from "react";

export const useRenameStyle = (styleId?: number) => {
  const intl = useIntl();
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mapkaNotification = useMapkaNotification();
  const { mutateAsync: updateStyle } = useMutation(trpc.updateStyle.mutationOptions());

  return useCallback((newStyleDisplayName: string) => {
    if (!styleId) return;

    updateStyle({
      update: {
        displayName: newStyleDisplayName,
      },
      styleId,
    })
      .then(() => {
        void queryClient.invalidateQueries(trpc.getStylesWithCurrentVersion.queryFilter());
        void queryClient.invalidateQueries(trpc.getUserActivities.queryFilter());
      })
      .catch((error: Error) => {
        logger.error({ error },
          "Failed to rename style",
        );
        mapkaNotification({
          message: intl.formatMessage({
            defaultMessage: "Rename failed",
            id: "card.renameFailed",
          }),
          variant: "error",
        });
      });
  }, [styleId, intl, trpc, mapkaNotification, updateStyle]);
};
